/**  
 * created by hezq on 2019-10-24
 * 
 * description：首页相关接口地址配置
 * 
 */

const config = require('libs/config.js');

const home = {
	
};

export default home;



// WEBPACK FOOTER //
// ./src/api/home/index.js